module.exports = __webpack_public_path__ + "static/media/header_logo.33e297ba.png";